var ccoConfigGet = require('../ccoConfigGet');
var olark = require('./olark');
var dummy = require('./dummy');
function getChatClient() {
  var clientName = ccoConfigGet('chatClient');
  if (clientName === 'olark') {
    return olark;
  }
  // return dummy client that implements noops for common functions
  return dummy;
}
module.exports = {
  getChatClient: getChatClient,
  chat: {
    init: function init() {
      return getChatClient().init();
    },
    onSuspendedLogin: function onSuspendedLogin() {
      return getChatClient().onSuspendedLogin();
    }
  }
};